export default __webpack_public_path__ + "static/media/btn_add_block.c2740b72.svg";